import parse from 'html-react-parser';
import { MockFormat } from 'postoffice-peripheral-management-service';
import { useEffect, useState } from 'react';

import Modal, { Title } from '@components/Modal';

interface ReceiptData {
  data: string;
  mockFormat: MockFormat;
}

// Used in dev/test environments to show a preview of the receipt being printed
export const ReceiptPreview = () => {
  const [receiptDataArray, setReceiptDataArray] = useState<ReceiptData[]>([]);

  const handleCloseModal = () => {
    setReceiptDataArray((prevArray) => prevArray.slice(1));
  };

  useEffect(() => {
    const receiptImageBroadcastChannel = new BroadcastChannel('receipt');
    const receiptHtmlBroadcastChannel = new BroadcastChannel('receiptHtml');

    receiptImageBroadcastChannel.onmessage = (event) => {
      setReceiptDataArray((prevArray) => [
        ...prevArray,
        { data: event.data, mockFormat: MockFormat.Image },
      ]);
    };
    receiptHtmlBroadcastChannel.onmessage = (event) => {
      setReceiptDataArray((prevArray) => [
        ...prevArray,
        { data: event.data, mockFormat: MockFormat.Html },
      ]);
    };

    return () => {
      receiptImageBroadcastChannel.close();
      receiptHtmlBroadcastChannel.close();
    };
  }, []);

  if (receiptDataArray.length === 0) {
    return null;
  }

  const currentReceipt = receiptDataArray[0];

  return (
    <Modal testId="receipt-preview-modal">
      <Title title="Receipt preview" closeIcon onClick={handleCloseModal} />
      {currentReceipt.mockFormat === MockFormat.Image ? (
        <img alt="Receipt preview" src={`data:image/png;base64,${currentReceipt.data}`} />
      ) : (
        parse(currentReceipt.data)
      )}
    </Modal>
  );
};
